





































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import topTitle from "@/components/faceCoupon/topTitle.vue";
import topStep from "@/components/faceCoupon/topStep.vue";

const faceCouponSuccess = namespace("faceCouponSuccess");
@Component({
  components: {
    topStep,
    topTitle
  }
})
export default class FaceCouponsSure extends Vue {
  titleName: string = "面对面赠券";
  stepsArry: Object = [
    { num: 1, name: "查询会员", class: "active" },
    { num: 2, name: "赠券", class: "active" },
    { num: 3, name: "完成", class: "active" }
  ]; /* 步骤 */
  value: Number = 0;
  faceCouponGetMoreList: any = JSON.parse(
    (sessionStorage as any).getItem("faceCouponGetMoreList")
  );
  backHome() {
    this.$router.push({ path: "/home" });
  }
}
